import React from 'react';

type Props = {
  className?: string;
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string;
};

const X2Icon: React.FC<Props> = ({ className, width = '16', height = '16', fill = 'none', stroke = '#0B1215' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 18 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path d="M13.5 4.5L4.5 13.5" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.5 4.5L13.5 13.5" stroke={stroke} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default X2Icon;
